import { INotificacao } from "../../types/Notificacao";

export enum EFeedEvents {
  ON_NOTIFICATION_RECEIVED = "ReceiveMessage",
  GET_OPEN_NOTIFICATION = "GetOpenNotification",
  SET_READ_NOTIFICATION = "SetReadNotification",
  SET_VIEW_NOTIFICATION = "SetViewNotification",
  DELETE_NOTIFICATION = "DeleteNotification"
}

export interface FeedDeNovidadesSignal {
  setup(options: IConnectOptions): Promise<void>;
  getOpenNotification(): Promise<void>;
  setReadNotification(
    params: Pick<ISetReadNotificationParams, "id" | "lido">
  ): Promise<void>;
  deleteNotification(
    params: Pick<IDeleteNotificationParams, "lidas">
  ): Promise<void>;
  setViewNotification(): Promise<void>;
}

export type IConnectOptions = {
  onNotificationReceived: (callback: INotificacao[]) => void;
};

export type IGetOpenNotificationParams = {
  customerId: string;
};

export type ISetReadNotificationParams = {
  id: INotificacao["id"] | null;
  lido: boolean;
  customerId: string;
};

export type IDeleteNotificationParams = {
  customerId: string;
  lidas?: boolean;
};

export type ISetViewNotificationParams = {
  customerId: string;
};
